import { ApiMethod, constructFetchFn } from '@utils/api';
import { API } from '@utils/constants';

export const template = (programId) => (
    constructFetchFn({
        method: ApiMethod.POST,
        url: API.TEMPLATE,
        body:{
            programId
        }
    })
);

export const submit = (programId, data) => (
    constructFetchFn({
        method: ApiMethod.POST,
        url: API.SUBMIT,
        body: {
            programId,
            data
        },
    })
);
